var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'user-change-list',
  created () {
    var readMore = false
    if (this.currentPage !== null && this.currentPage >= 1) {
      readMore = 'keepload'
    }

    utils.backClear()

    this.shopGet()
    this.usertypeGet()

    var ssShopIds = window.sessionStorage.getItem("shopIds")
    var ssUserName = window.sessionStorage.getItem("userName")
    var ssUserTypeIds = window.sessionStorage.getItem("userTypeIds")

    if (ssShopIds == null || ssShopIds.length == 0) {
      if ((this.isSystemManagement || this.isAppIncluding) && (window.sessionStorage.getItem('shopNull') == 'on')) {
        this.shopIds = []
      } else {
        this.shopIds = window.localStorage.getItem("shop_id").split(",")
      }
    } else {
      this.shopIds = ssShopIds.split(",")
      if (this.shopIds.length == 1 && this.shopIds[0] == 800) {
        this.shopIds = window.localStorage.getItem("shop_id").split(",")
      } else {
        //退職者一覧店舗を表示しない
        var workIndex = 0
        for (var i=0; i < this.shopIds.length; i++) {
          if (this.shopIds[i] == 800) {
            workIndex = i
            break;
          }
        }
        if (workIndex != 0) {
          this.shopIds.splice(workIndex,1)
        }
      }
    }
    if (ssUserName !== null) {
      this.userName = ssUserName
    }
    if (ssUserTypeIds == null || ssUserTypeIds.length == 0) {
    } else {
      this.usertypeIds = ssUserTypeIds.split(",")
    }

    // ソート設定
    this.loadSortState()

    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      shopName: '',
      userName: '',
      usertypeName: '',
      searchCallbackFlag: false,
      shopGetCallbackFlag: false,
      usertypeGetCallbackFlag: false,
      sortKey: '',
      sortStateOrder: '',
      sortState: {
        'login_id':       {'state': false, 'order': false},
        'user_name':      {'state': false, 'order': false},
        'shop_name':      {'state': false, 'order': false},
        'age':            {'state': false, 'order': false},
        'user_type_name': {'state': true, 'order': true},
        'change_day':     {'state': false, 'order': false}
      },
      shopIds: [],
      usertypeIds: [],
      searchTotalCount: 0
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
    users () {
      return this.$store.getters.users
    },
    shops () {
      return this.$store.getters.shopsAll
    },
    usertypes () {
      return this.$store.getters.usertypesAll
    },
    nextPage () {
      return this.$store.getters.usersNextPage
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    currentPage () {
      return this.$store.getters.usersCurrentPage
    },
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isAppIncluding () {
      return this.$store.getters.isAppIncluding
    },
    isAppNotIncluded () {
      return this.$store.getters.isAppNotIncluded
    },
    isBrowsIncluding () {
      return this.$store.getters.isBrowsIncluding
    },
    localShopId () {
      return window.localStorage.getItem('shop_id')
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    },
    getImgClass: function() {
      return (this.isBrowsIncluding)? 'padding-left':''
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function (readMore) {
      if (this.shopIds.length !== 0) {
        window.sessionStorage.setItem('shopIds', this.shopIds)
      } else {
        window.sessionStorage.setItem('shopNull', 'on')
        window.sessionStorage.removeItem('shopIds')
      }
      if (this.userName !== null) {
        window.sessionStorage.setItem('userName', this.userName)
      } else {
        window.sessionStorage.removeItem('userName')
      }
      if (this.usertypeIds !== '') {
        window.sessionStorage.setItem('userTypeIds', this.usertypeIds)
      }

      // ソート保存
      this.saveSortState()

      var url = null
      if (readMore) {
        url = this.$store.getters.usersNextPage
      } else {
        this.searchCallbackFlag = false
      }
      var self = this
      var callback = function (totalCount) {
        self.searchTotalCount = totalCount
        self.searchCallbackFlag = true
      }
      var data = {
        'shop_ids': this.shopIds,
        'user_name': this.userName,
        'user_type_ids': this.usertypeIds,
        'order': this.orderByString(),
        'shop_id': ""
      }

      if (readMore === 'sort' || readMore === 'keepload') {
        // ソート、再読込 現在のページを指定
        data['current_page'] = this.currentPage
      } else {
        data['current_page'] = null
      }

      this.$store.dispatch('USER_LIST_SEARCH', {url: url, data: data, callback: callback})
    },
    sortBy: function(key) {
      this.sortKey = key
      this.sortStateOrder = !this.sortState[key].order
      for (var k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      this.sortState[key].state = true
      this.sortState[key].order = !this.sortState[key].order
      // 検索
      this.search('sort')
    },
    shopGet: function() {
      var self = this
      var callback = function (){
        self.shopGetCallbackFlag = true
        //退職者一覧店舗を表示しない
        var workIndex = 0
        for (var i=0; i < self.shops.length; i++) {
          if (self.shops[i].id == 800) {
            workIndex = i
            break;
          }
        }
        if (workIndex != 0) {
          self.shops.splice(workIndex,1)
        }
      }

      this.$store.dispatch('SHOP_ALL_GET', {callback: callback})
    },
    usertypeGet: function() {
      var self = this
      var callback = function (){
        self.usertypeGetCallbackFlag = true
      }
      this.$store.dispatch('USERTYPE_ALL_GET', {callback: callback})
    },
    getArrow: function(key) {
      var state = this.sortState[key].state ? ' color-light-blue' : ''
      var arrow = this.sortState[key].order ? 'fa-arrow-up' : 'fa-arrow-down'
      return arrow + state
    },
    /** ソート文字列取得 */
    orderByString: function() {
      var result = []
      for (var key in this.sortState) {
        if (this.sortState[key].state) {
          var asc_desc = 'asc'
          if (!this.sortState[key].order) {
            asc_desc = 'desc'
          }
          result.push(key + ' ' + asc_desc)
        }
      }
      if (result.length <= 0) {
        // 存在しない場合
        result.push('login_id asc')
      }
      return result.join(' , ')
    },
    goPhotoLists: function () {
      utils.backClear()
      this.$router.push({ path: '/userphotos', query: { type: this.$router.currentRoute.query.type}})
    },
    goShopLists: function () {
      utils.backClear()
      this.$router.push({ path: '/shops', query: { type: this.$router.currentRoute.query.type}})
    },
    goUserLists: function () {
      utils.backClear()
      this.$router.push({ path: '/users', query: { type: this.$router.currentRoute.query.type}})
    },
    goRitireeLists: function() {
      utils.backClear()
      this.$router.push({ path: '/retiree', query: { type: this.$router.currentRoute.query.type}})
    },
    goUserDetail: function (userId) {
      window.sessionStorage.setItem('BackPage', '/userchanges/')
      this.$router.push({ path: '/userhistory/' + userId })
    },
    half: function () {
      this.userName = utils.emHalf(this.userName)
    },
    /** 画像押下 */
    onClickImageModalShow: function (user) {
      var button = document.getElementById('imageModalButton')
      var img    = document.getElementById('imageModalImg')
      var text   = document.getElementById('imageModalText')
      img.src = user.attributes['avartar-path'] + '?token=' + this.authToken + "&timestamp=" + self.timeStamp
      text.textContent = ''
      button.click() // モーダル表示 イベント発火
    },
    /** ソート設定 */
    loadSortState: function() {
      var ssSortStateJSON = window.sessionStorage.getItem("sortState")
      if (!ssSortStateJSON) {
        return
      }
      var state = false
      var ssSortState = JSON.parse(ssSortStateJSON)
      if (!ssSortState['user_type_name']) {
        this.sortState['user_type_name'] = {'state': false, 'order': true}
      }
      for (var key in ssSortState) {
        if (this.sortState[key]) {
          this.sortState[key] = ssSortState[key]
          state |= ssSortState[key].state
        }
      }
      if (!state) {
        this.sortState['user_type_name'] = {'state': true, 'order': true}
      }
    },
    /** ソート保存 */
    saveSortState: function() {
      var ssSortState = JSON.parse(JSON.stringify(this.sortState))
      var ssSortStateJSON = window.sessionStorage.getItem("sortState")
      if (ssSortStateJSON) {
        ssSortState = JSON.parse(ssSortStateJSON)
        for (var key in ssSortState) {
          ssSortState[key] = {'state': false, 'order': false}
        }
        for (var key in this.sortState) {
          if (this.sortState[key]) {
            ssSortState[key] = this.sortState[key]
          }
        }
      }
      window.sessionStorage.setItem('sortState', JSON.stringify(ssSortState))
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/user-change-list.js